import React from 'react';
import { motion } from 'framer-motion';
export function CTASection() {
  return <section className="relative py-32 overflow-hidden" data-id="element-74">
      {/* Animated Gradient Background */}
      <div className="absolute inset-0 gradient-animate opacity-90" data-id="element-75"></div>
      <div className="absolute inset-0 grid-pattern opacity-20 mix-blend-overlay" data-id="element-76"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-77">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-78">
          Ready to Transform Your Enterprise with AI?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl text-white/80 mb-10 max-w-2xl mx-auto" data-id="element-79">
          Partner with Kenya's leading AI solutions company. Let's build the
          future together.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-80">
          <a href="#contact" className="w-full sm:w-auto px-8 py-4 bg-white text-brand-dark hover:bg-gray-100 rounded-full font-bold transition-all duration-300 shadow-[0_0_30px_rgba(255,255,255,0.3)] hover:shadow-[0_0_40px_rgba(255,255,255,0.5)] text-lg" data-id="element-81">
            Schedule a Consultation
          </a>
          <a href="tel:+254724570060" className="w-full sm:w-auto px-8 py-4 bg-transparent border-2 border-white hover:bg-white/10 text-white rounded-full font-bold transition-all duration-300 text-lg" data-id="element-82">
            Call Us: +254 724 570 060
          </a>
        </motion.div>
      </div>
    </section>;
}